// @flow
import React, { useState } from 'react';

// IMPORTING CSS
import 'assets/css/shared.css';
import './styles.css';

// IMPORT IMAGES
import bgImage from 'assets/images/background.png';
import gsIcon from 'assets/images/logo-2x.png';
import passSuccessIcon from 'assets/images/recover-pass-success-icon.png';
import downloadApple from 'assets/images/download-apple.png';
import downloadGoogle from 'assets/images/download-google.png';

import { useTranslation } from 'react-i18next';

const ChangePasswordSuccessView = (props: Props) => { 

  const { t } = useTranslation();

  return (
    <>
     <div style={{ backgroundImage: `url(${bgImage})` }} className="recover-password-container">
        <div className="logo-container">
          <img className="image-responsive recover-password-logo" src={gsIcon} />
        </div>

        <div className="containers success-password">
            <div className="auth-modal">
                <div className="auth-modal-content">
                    <div className="auth-modal-content">
                        <img className="image-responsive" src={passSuccessIcon} />
                    </div>

                    <div className="auth-modal-content-heading success-password-heading">
                        <h2 id="pageTitle">Your Password was changed successfully!</h2>
                    </div>

                    <div className="auth-modal-content">
                        <p className="success-text">You can use your new password to login to Goalsetter via our Android or iOS app, on any phone or mobile device.</p>
                    </div>
               
                    <div className="auth-modal-content download-buttons">
                        <div className="download-apple-button">
                          <a href='https://itunes.apple.com/us/app/goalsetter-co/id1440624866' target="_blank" rel="noopener noreferrer">
                            <img className="image-responsive" src={downloadApple} />
                          </a>
                        </div>

                        <div className="download-google-button">
                          <a id="btnDownloadAndroid" href={'https://play.google.com/store/apps/details?id=com.goalsetter'} target="_blank" rel="noopener noreferrer">
                            <img className="image-responsive" src={downloadGoogle} />
                          </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
    </>
  );
};

export default ChangePasswordSuccessView;
